import CustomError from './CustomError';
import { getErrorMessage } from './getErrorMessage';

class HTTPError extends CustomError {
  constructor(private errorCode: string, message?: string) {
    super(message);
    this.name = 'HTTPError';
    this.errorCode = errorCode;
  }

  get codeToErrorMessage() {
    return getErrorMessage(this.errorCode);
  }
}

export default HTTPError;
